import React from 'react';
import { Link } from 'react-router-dom';
import { Wallet, LogOut, Settings, Mail } from 'lucide-react';
import CopyButton from '../CopyButton';
import NotificationBell from '../NotificationBell';

const WebsiteHeader = ({ user, userOwnAlias, onLogoClick, onLogin, onLogout, onProfileClick }) => {
  const isEmailUser = user?.authMethod === 'email';

  return (
    <div className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:py-4 flex items-center justify-between">
        <Link
          to="/"
          onClick={onLogoClick}
          className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition flex-shrink-0"
        >
          <img src="/logo192.png" alt="CoinCommons" className="w-8 h-8 sm:w-10 sm:h-10 rounded" />
          <h1 className="text-lg sm:text-2xl font-bold text-gray-800">CoinCommons</h1>
        </Link>

        {user ? (
          <div className="flex items-center gap-1 sm:gap-2 md:gap-3">
            {isEmailUser ? (
              // Email user display
              <div className="flex items-center gap-2 bg-gradient-to-br from-green-500 to-teal-600 text-white px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg max-w-[140px] sm:max-w-[200px]">
                <Mail className="w-4 h-4 hidden sm:block flex-shrink-0" />
                <div className="flex flex-col leading-tight min-w-0">
                  <span className="text-xs sm:text-sm truncate">{user.displayName || user.username}</span>
                  <span className="text-[10px] sm:text-xs opacity-75 truncate">@{user.username}</span>
                </div>
              </div>
            ) : (
              // Wallet user display
              <div className="flex items-center gap-2 bg-gradient-to-br from-blue-500 to-purple-600 text-white px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg max-w-[140px] sm:max-w-[200px]">
                <Wallet className="w-4 h-4 hidden sm:block flex-shrink-0" />
                <span className="font-mono text-xs sm:text-sm truncate min-w-0">{userOwnAlias || user.displayAddress}</span>
                <div className="hidden sm:block flex-shrink-0 ml-1 [&_button]:!text-white [&_button]:hover:!bg-white/20 [&_svg]:!text-white">
                  <CopyButton text={user.address} label="address" />
                </div>
              </div>
            )}
            <NotificationBell user={user} />
            {onProfileClick && (
              <button
                onClick={onProfileClick}
                className="p-1.5 sm:p-2 hover:bg-gray-200 rounded-lg transition"
                title="Settings"
              >
                <Settings className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
              </button>
            )}
            <button
              onClick={onLogout}
              className="p-1.5 sm:p-2 hover:bg-gray-200 rounded-lg transition"
              title="Sign Out"
            >
              <LogOut className="w-4 h-4 sm:w-5 sm:h-5 text-gray-700" />
            </button>
          </div>
        ) : (
          <button
            onClick={onLogin}
            className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-3 sm:px-4 py-2 rounded-lg hover:from-blue-700 hover:to-purple-700 transition font-medium text-sm sm:text-base"
          >
            <Wallet className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="hidden sm:inline">Sign In</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default WebsiteHeader;
